
export class PhoneModel {
  public Id: number;
  public PhoneNumber: string;
  public IsMain: boolean;
  public IsShown: boolean;
  public PhoneType: number;
  public PhoneTypeDescription: string;
  public Notes: string;
  public DateCreated: Date;
  public DateModified: Date;
  public DateDeleted: Date;
  public Deleted: boolean;

  constructor(phoneNumber: string) {
    this.PhoneNumber = phoneNumber;
    this.IsMain = true;
  }

}

export class AddressViewModel {
  public Id: number;
  public IsMain: boolean;
  public IsNew: boolean;
  public Address: string;
  public AddressDescription: string;
  public PostalCode: string;
  public City: string;
  public State: string;
  public Country: string;
  public Region: string;
  public Notes: string;
  public AddressType: number;
  public AddressTypeDescription: string;
  public DateCreated: Date;
  public DateModified: Date;
  public DateDeleted?: Date;
  public Deleted: boolean;
  public LeftSectionFontAwesomeIconClass: string;
  public IsEditing: boolean;

  constructor(country: string, postalCode: string, address: string, city: string, state: string) {
	  this.Country = country;
    this.PostalCode = postalCode;
    this.City = city;
    this.State = state;
    this.Address = address;
    this.IsMain = true;
  }
}

enum MemberTypes {
  Unknown,
  Consumer,
  ConsumerExtended,
  ConsumerPremium,
  ConsumerExpert,
  Professional,
  ProfessionalExtended,
  ProfessionalPremium,
  ProfessionalExpert,
  Reviewer,
  IndustryExpert
}

enum MemberPrivilege {
  OnHold = -1,
  Suspended = -1,
  Unknown = 0,
  Pending,
  Verified,
  Subscribed,
  Extended,
  Administrator,
  Developer
}

export class RegisterModel {

  constructor() {
    this.phoneViewModel = new PhoneModel('');
    this.addressViewModel = new AddressViewModel('US', '', '', '', '');
  }

  public referId: number;
  public referName: string;
  public email: string;
  public firstName: string;
  public lastName: string;
  public middleName: string;
  public suffice: string;
  public title: string;
  public degrees: string;
  public companyName: string;
  public phoneViewModel: PhoneModel;
  public addressViewModel: AddressViewModel;
  public memberType: MemberTypes = 0;
  public status = 0;
  public termsAgree: boolean;
  public corp: number;
  public privilege = 0;
  public hasProfileToClaim: boolean;
  public registeringToClaimProfile: boolean;
  public alreadyAddedToServer: boolean;
  public registrationCodeValid: boolean;
  public registrationCode: string;
  // [Required]
  public password: string;
  public confirmPassword: string;
  public externalProviderKey: string;
  public externalProviderName: string;
  public useExternalProvider: boolean;
}

export class RespCheckEmailModel {
  hasProfileToClaim: boolean;
  emailAlreadyInUse: boolean;
  emailError: boolean;
  memberStatus: number;
  hasProfessionalRec: false;
  professionalModel: any;
  emailErrorMessage: string;
}

export class SignupResultModel {
  resultStatus: number;
  resultMessage: string;
  hasProfileToClaim: boolean;
  hasProfessionalRec: boolean;
  emailAlreadyInUse: boolean;
  emailError: boolean;
  memberStatus: number;
  professionalModel: any;
  provider: string;
  providerID: string;
  hasProfessionalAreas: boolean;
  maskedEmail: string;
}
